import { Icon } from '@unifocus/react-icons';
import {
   faChevronDoubleLeft, faChevronDoubleRight,
   faChevronLeft,
   faChevronRight
} from '@fortawesome/pro-regular-svg-icons';
import React, { useCallback } from 'react';
import { HorizontalPanel } from '../../layout/horizontalpanel';
import { Button } from '../button';
import { HorizontalSpacer } from '../../layout/horizontalspacer';
import { debounce } from 'lodash';

const leftNextIcon = <Icon icon={faChevronLeft}/>;
const leftEndIcon = <Icon icon={faChevronDoubleLeft}/>;
const rightNextIcon = <Icon icon={faChevronRight}/>;
const rightEndIcon = <Icon icon={faChevronDoubleRight}/>;

type DirectionType = 'left' | 'right';

export interface SimplePaginationButtonsProps {
   direction: DirectionType;
   size?: 'default' | 'small';
   onPageClick: (direction: DirectionType) => void;
   onLimitClick: (direction: DirectionType) => void;
   disabled?: boolean;
}

export const SimplePaginationButtons = (props: SimplePaginationButtonsProps) => {

   const { direction, size, onPageClick, onLimitClick, disabled } = props;

   const debouncedOnPageClick = debounce(onPageClick, 100);

   const onLeftPageClick = useCallback(() => {
      debouncedOnPageClick('left');
   },[debouncedOnPageClick]);

   const onLeftLimitClick = useCallback(() => {
      onLimitClick('left');
   },[onLimitClick]);

   const onRightPageClick = useCallback(() => {
      debouncedOnPageClick('right');
   },[debouncedOnPageClick]);

   const onRightLimitClick = useCallback(() => {
      onLimitClick('right');
   },[onLimitClick]);

   if (direction === 'left') {
      return (<HorizontalPanel align={'left'} className={'uf-simple-pagination-buttons'}>
         <Button icon={leftEndIcon} size={size==='small' ? 'small' : 'middle'} onClick={onLeftLimitClick} disabled={disabled}/>
         <HorizontalSpacer size={'small'}/>
         <Button icon={leftNextIcon} size={size==='small' ? 'small' : 'middle'} onClick={onLeftPageClick} disabled={disabled}/>
      </HorizontalPanel>);
   }

   return (<HorizontalPanel align={'right'} className={'uf-simple-pagination-buttons'}>
      <Button icon={rightNextIcon} size={size==='small' ? 'small' : 'middle'} onClick={onRightPageClick} disabled={disabled}/>
      <HorizontalSpacer size={'small'}/>
      <Button icon={rightEndIcon} size={size==='small' ? 'small' : 'middle'} onClick={onRightLimitClick} disabled={disabled}/>
   </HorizontalPanel>);
}
